import { Button, Input } from "@heroui/react";
import React from "react";
import { useTranslation } from "react-i18next";

import { formatDate } from "@wc/domain/dates";
import { ReactComponent as TickIcon } from "@wc/ui/assets/icons/tick-circle.svg";

/**
 * @param {object} props Component props
 * @param {string} props.token The invite token
 * @param {Date} [props.expiresAt] When the invite expires
 * @returns {React.ReactElement} Invite link display with copy button
 */
export default function InviteLinkDisplay({ token, expiresAt }) {
  const { t } = useTranslation();
  const [copied, setCopied] = React.useState(false);

  const inviteUrl = `${window.location.origin}/invite/${token}`;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(inviteUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      console.error("Failed to copy:", error);
    }
  };

  return (
    <div className="space-y-2">
      <div className="flex gap-2">
        <Input
          readOnly
          value={inviteUrl}
          aria-label="Invite link"
          classNames={{
            input: "text-sm",
          }}
        />
        <Button
          variant="flat"
          onPress={handleCopy}
          aria-label={copied ? t("invites.copied") : t("invites.copy")}
        >
          {copied ? (
            <TickIcon className="text-success size-5" />
          ) : (
            t("invites.copy")
          )}
        </Button>
      </div>
      {expiresAt && (
        <p className="text-default-400 text-sm">
          {t("invites.expiresAt", {
            date: formatDate(expiresAt),
          })}
        </p>
      )}
    </div>
  );
}
